<template>
  <nav :aria-label="$t('tuka.navigation.table_of_contents')" :class="sideNavCss()">
    <div class="settings-box visual-settings d-lg-none mb-lg-0 pl-lg-3">

      <button
          class='visual-settings-button icon-arrow accordion-button'
          :class="getSettings.showContentWindowInFullWidth ? 'tuka-arrow-down' : 'tuka-arrow-up' "
          @click="toggleContentWindowInFullWidth()"
          :aria-label="getSettings.showContentWindowInFullWidth ?
          ($t('tuka.navigation.sidebar_closed') + ', ' + $t('tuka.navigation.open_sidebar') )
          : $t('tuka.navigation.sidebar_open') + ', ' + $t('tuka.navigation.close_sidebar') "
          :aria-expanded="getSettings.showContentWindowInFullWidth ? 'false' : 'true'"
      >
      <span 
        class="visual-settings-button-info"
        v-if="!getSettings.showContentWindowInFullWidth"
      >{{$t('tuka.navigation.close_sidebar')}}</span>
      <span 
        class="visual-settings-button-info"
        v-if="getSettings.showContentWindowInFullWidth"
      >{{$t('tuka.navigation.open_sidebar')}}</span>
      </button>

    </div>
    <search-box class="pl-lg-3" />
    <div class="fp pl-lg-0">
      <div class="initial-header ml-lg-3">
        <h2 class="table-of-contents" v-html="tableOfContentsText()"></h2>
        <div 
          class="side-nav-item-header main-header"
          v-if="this.sidebarContent[0]"
        >
          <a 
            class="name"
            href="#"
            @click.prevent="updateUrl()"
            :id="false"
          >
          {{$t('tuka.navigation.show_all_content')}}
          </a>
        </div>
      </div>

      <div 
        class="initial" 
        v-if="this.sidebarContent[0]"
      >
          <div class="display-accordion-button side-nav-list-button">
            <button
              class='accordion-button'
              :class="accordion.open ? 'icon-arrow-down' : 'icon-arrow-up'"
              @click="accordion.open = !accordion.open"
              :aria-label="accordion.open ? 'Accordion open' : 'Accordion closed'"
              :aria-expanded="accordion.open ? 'true' : 'false'"
              aria-controls="side-nav-list"
            >
            </button>
          </div>
          <ul 
            id="side-nav-list" 
            :class="accordion.open ? 'level-' + 0 + ' open' : 'level-' + 0 + ' closed'"
            v-show="accordion.open"
            >
            <list-tree 
              :item="sidebarContent[0]" 
              :index="0"
              :singleItemIndex="0"
              :locationArray="sidebarContent[0].locationData"
              :navigationIndex="sidebarContent[0].navigationIndex" 
              :parentsArray="[]"
              :hasAccordion="false"
              :key="id"
            />
          </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ListTree from "./ListTree.vue";
import SearchBox from "./SearchBox.vue";
import { i18n } from "../translations/i18n";

import * as http from "../http";

export default {
  name: "SideNavigationList",
  components: {
    ListTree,
    SearchBox
  },
  data() {
    return {
      id: null,
      ContentWindowInFullWidth: false,
      accordion: {
        open: true
      },
    };
  },
  mounted() {
    this.id = this._uid;
  },
  computed: {
    ...mapGetters(["sidebarContent", "getSettings", "getFilters", "themeWords"]),
  },
  methods: {
    ...mapActions(["setSettings", "setSearchResults", "setScrollingReserved"]),
    sideNavCss() {
      if (this.getSettings.showContentWindowInFullWidth) {
        return "col col-md-12 col-lg-4 sidebar-hidden";
      }
      return "col col-md-12 col-lg-4";
    },
    toggleContentWindowInFullWidth() {
      let tempSettings = this.getSettings;
      tempSettings.showContentWindowInFullWidth = !tempSettings.showContentWindowInFullWidth;

      this.setSettings(tempSettings);
    },
    tableOfContentsText() {
      let text = i18n.messages[i18n.locale].tuka.navigation.table_of_contents;

      // If themeWords filter is active, display filtered themeword info
      if (this.getFilters.themeWords == true) {

        // TODO: add switch for showing different message
        if (false) {
          let activeThemeWords = "";
          Object.keys(this.themeWords).forEach(key => {
            if (this.themeWords[key] == true) {
              activeThemeWords += '<span class="single-themeword">' + key + '</span>';
            }
          })
          text = i18n.messages[i18n.locale].tuka.navigation.table_of_contents_filtered + activeThemeWords;
        }

        text = i18n.messages[i18n.locale].tuka.navigation.table_of_contents_filtered_simple;
      }
      return text;
    },
    updateUrl() {

      let pushParams = {
        componentPage: this.$router.currentRoute.params.componentPage,
        componentId: [],
      }

      this.$router.push({
        name: 'componentpage',
        params: pushParams,
        query: {},
        hash: undefined
      }).catch(err => { console.log("Reroute to same location, avoiding")})

      // Remove search results from view
      this.setSearchResults({ "errorMessage":"", "data":[] });

      // Scroll into top of main content
      this.$nextTick(() => {
        this.setScrollingReserved(true);

        // Go to top of scrollable sidebar list
        let scrollElement = document.querySelector(".tukave-side-nav");
        scrollElement.querySelector(".initial").scrollTo({
          top: 0
        });

        setTimeout(() => {
          let scrollTarget = jQuery('.tukave-main-content');
          scrollTarget[0].scrollIntoView({behavior: "smooth"});
        }, 100);

        setTimeout(() => {
          this.setScrollingReserved(false);
        }, 2000)

        // Focus main content area
        document.getElementById('tuka-content-container').focus({
          preventScroll: true
        });
      });

    }
  },
};
</script>

<style lang="scss">


</style>
